<template>
  <Block class="course-outline-instruction this-block"
    label="แนะนำวิธีการเรียน"
    collapsible
    lift
  >

    <div slot="header" class="-header">
      <div class="--title">
        <span>แนะนำวิธีการเรียน</span>
      </div>
      <div class="--controllers">
        <vx-tooltip text="Edit">
          <vs-button
            class="controller-buttons"
            radius
            color="gray"
            type="gradient"
            icon="edit"
            @click="$emit('call-editor', 'edit-instruction', { mode: 'edit', data: { instruction, streamIntroPath } })"
          />
        </vx-tooltip>
      </div>
    </div>

    <div class="-body">
      <div id="instruction-text" class="--left">
        {{ instruction }}
      </div>
      <div id="instruction-video" class="--right">
        <VideoPlayer
          v-if="validStream"
          :options="videoOptions" ref="videoPlayer"
        />
        <div v-else>
          No Video
        </div>
      </div>
    </div>
  </Block>
</template>

<script>
import { Block } from "@/components/common-ui";
import VideoPlayer from "@/components/common-ui/video-player";

export default {
  components: {
    Block,
    VideoPlayer
  },
  props: {
    instruction: String,
    streamIntroPath: String,
  },
  data() {
    return {
      videoOptions: {
        autoplay: false,
        controls: false,
        fluid: true,
        nativeControlsForTouch: true,
        sources: [
          {
            src: this.streamIntroPath,
            type: "video/mp4"
          }
        ]
      }
    }
  },
  watch: {
    'streamIntroPath'(uri) {
      this.videoOptions.sources = [ { src: uri, type: "video/mp4" }];
      if (this.$refs.videoPlayer) {
        const videoPlayer = this.$refs.videoPlayer;
        if (Object.prototype.hasOwnProperty.call(videoPlayer, 'player')) {
          videoPlayer.player.play();
        }
      }
    }
  },
  computed: {
    validStream() {
      if (
        this.streamIntroPath !== null
        && this.streamIntroPath !== ''
      ) {
        return true;
      }
      return false;
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'common-scoped';

.this-block {
  min-height: 200px;

  & .-header {
    // background: rgb(255, 221, 232);
    color: white;
    background: #67799c;
  }

  & .-title {
    & > span {
      font-size: 1.3rem;
    }
  }

  & .-body {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    height: 100%;

    & > div {
      width: 50%;
    }

    & .--left {
      order: 1;
    }

    & .--right {
      order: 2;
    }
  }
}

#instruction-text{
  flex-grow: 3;
  & > span {
    font-size: 0.9rem;
  }
}

#instruction-video {
  flex-grow: 1;
  & > span {
    font-size: 0.9rem;
    color: red;
  }
}

</style>
